import AuthLayout from "./AuthLayout";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import OTPInput from "react-otp-input";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { showError, showToast } from "../../constants/toasts";
import {
  usePostForgotPasswordMutation,
  usePostVerifyOtpMutation,
} from "../../service/auth";
import { setCredentials, temporaryToken } from "../../reducers/authSlice";
import { useAppDispatch } from "../../hooks/store";
import { setToStorage, STORAGE_KEYS } from "../../helpers";

const OtpVerification = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [optVerificationMutation] = usePostVerifyOtpMutation();
  const [ForgotPasswordMutation] = usePostForgotPasswordMutation();

  const [otp, setOtp] = useState<string>("");
  const location = useLocation();
  const method = location.state?.method || "email";
  const email = location.state?.email || "";
  const phone = location.state?.phone || "";
  const countryCode = location.state?.countryCode || "";
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const [loading, setLoading] = useState(false);
  const [countDown, setCountDown] = useState<number>(59);

  // Conditionally define the text
  const otpText =
    method === "phone"
      ? "A verification OTP has been sent to your phone number. Please check your messages."
      : "A verification OTP has been sent to your email. Please check your inbox.";

  const getTitle = () => {
    if (type === "forgotPassword") return "";
    if (type === "phoneLogin") return "";
    if (type === "signup") return "";
  };

  const handleSubmit = async () => {
    if (otp?.length != 4) {
      showError("Please enter OTP");
      return;
    }
    if (otp?.length === 4) {
      const body = {
        ...(type === "phoneLogin"
          ? { phone, countryCode: "+" + countryCode }
          : { email }),
        otp: otp,
        otpType: type === "phoneLogin" ? 2 : 3,
      };
      setLoading(true);
      try {
        const response = await optVerificationMutation(body).unwrap();
        if (response?.statusCode === 200) {
          setLoading(false);

          if (type === "phoneLogin") {
            setToStorage(STORAGE_KEYS.token, response?.data?.token || "");
            setToStorage(STORAGE_KEYS.userData, JSON.stringify(response?.data));
            dispatch(
              setCredentials({
                user: response?.data || null,
                token: response?.data?.token || "",
              })
            );
            navigate("/dashboard");
            showToast("OTP verified successfully");
          } else {
            dispatch(
              temporaryToken({ tempToken: response?.data?.token || null })
            );
            showToast("OTP verified successfully");

            navigate("/reset-password", {
              replace: true,
            });
          }
        } else {
          setLoading(false);
          setOtp("");
        }
      } catch (error: any) {
        setLoading(false);
        setOtp("");
        if (error?.data?.message) {
          showError(error?.data?.message || "");
        }
      }
    }
  };

  const handleResendOtp = async (e: any) => {
    e.preventDefault();
    const body = {
      email,
      otpType: 3,
    };

    try {
      setLoading(true);
      const response = await ForgotPasswordMutation(body).unwrap();
      setLoading(false);
      if (response?.statusCode === 200) {
        showToast("OTP Resent Successfully");
        setCountDown(59);
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    if (countDown > 0) {
      setTimeout(() => {
        setCountDown(countDown - 1);
      }, 1000);
    } else {
      setCountDown(0);
    }
  }, [countDown]);

  return (
    <AuthLayout>
      <div className="authBox">
        <h2>Verify {getTitle()}</h2> <p>{otpText}</p>
        <form className="form">
          <div className="control_group">
            <div className="opt_fields">
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={4}
                renderInput={(props) => <input {...props} id="otp" />}
                inputType="tel"
                shouldAutoFocus
              />
            </div>
            <div className="auth_bottom">
              <p>
                <span
                  className="link"
                  onClick={(e) => {
                    if (countDown === 0) {
                      handleResendOtp(e);
                    } else {
                      return;
                    }
                  }}
                >
                  Resent OTP
                  {countDown !== 0 ? (
                    <span
                      style={{
                        margin: 0,
                      }}
                    >
                      (00:{countDown < 10 ? `0${countDown}` : countDown})
                    </span>
                  ) : null}
                </span>
              </p>
            </div>
          </div>
          <div className="form_btn">
            <Button className="btn btn_primary w_100" onClick={handleSubmit}>
              Submit
            </Button>
          </div>
        </form>
        <div className="auth_bottom">
          <p>
            <button className="link" onClick={() => navigate("/")}>
              <KeyboardBackspaceIcon /> Back to Login
            </button>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default OtpVerification;
